import { QueryClient } from '@tanstack/react-query'
import { ApiError } from '../api/client.ts'

/**
 * Server data lives here and nowhere else. Nothing in this app copies a query result into a
 * store; a Zustand store holds only state the server has never heard of.
 */
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 30_000,
			refetchOnWindowFocus: false,
			// A 4xx is an answer, not a network blip: retrying it just delays the message.
			retry: (failureCount, error) =>
				!(error instanceof ApiError && error.status < 500) && failureCount < 2,
		},
		mutations: { retry: false },
	},
})
